import { render, staticRenderFns } from "./FiltersButton.vue?vue&type=template&id=1bb4e7f5&scoped=true&"
import script from "./FiltersButton.vue?vue&type=script&lang=js&"
export * from "./FiltersButton.vue?vue&type=script&lang=js&"
import style0 from "./FiltersButton.vue?vue&type=style&index=0&id=1bb4e7f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4e7f5",
  null
  
)

export default component.exports